import React, { useEffect, useState, useContext } from "react";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import TooltipConfig from "../../../../Tooltip";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
import { Table } from "react-bootstrap";

export const TableList = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [totalUntil11, setTotalUntil11] = useState<number[]>([]);
  const [totalUntil14, setTotalUntil14] = useState<number[]>([]);
  const [totalAfter14, setTotalAfter14] = useState<number[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {    
    setTotalUntil11([
      Number(data.total.until_11.today),
      Number(data.total.until_14.today),
      Number(data.total.after_14.today),     
    ]);
    setTotalUntil14([
      Number(data.total.until_11.last_weekdays_avg),
      Number(data.total.until_14.last_weekdays_avg),
      Number(data.total.after_14.last_weekdays_avg),
    ]);
    setTotalAfter14([
      Number(data.total.until_11.last_weeks_avg),
      Number(data.total.until_14.last_weeks_avg),
      Number(data.total.after_14.last_weeks_avg),
    ]);
    setCategories([
      'Até as 11:00',
      'Até as 14:00',
      'A partir das 14:00'
    ])
    const sizes = getSizesComponent({ id: "table-routes-finished-on-interval" });
    if (sizes.width < 345) {
      setFontSize({ id: "table-routes-finished-on-interval", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setCompleteRequisition(true);
  }, [data]);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Tabela - Quantidade e Faixa Horário de Término Real % das Rotas`}
        id="table-routes-finished-on-interval"
      />
      <div
        id={"paddedBox"}
      >
        <div id="chart" style={{ height: heightChart }}>
          <Table
            id="tableRoutesFinishedOnInterval"
            style={{ color: '#fff', textAlign: "center"}}
            bordered
          >
            <thead>
              <tr>
                <th>Horário</th>
                <th>Dia Atual</th>
                <th>Histórico Dia x Dia</th>
                <th>Média Histórica Geral</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((elem: string, i: number) => {
                return (
                  <tr id={"row_" + i}>
                    <td>{elem}</td>
                    <td>
                      <TooltipConfig
                        content={[`${((totalUntil11[i]/(totalUntil11[0] + totalUntil11[1] + totalUntil11[2])) * 100).toFixed(2)}%`]}
                        children={totalUntil11[i]}
                        style={false}
                      />
                    </td>
                    <td>
                      <TooltipConfig
                        content={[`${((totalUntil14[i]/(totalUntil14[0] + totalUntil14[1] + totalUntil14[2])) * 100).toFixed(2)}%`]}
                        children={totalUntil14[i]}
                        style={false}
                      />
                    </td>
                    <td>
                      <TooltipConfig
                        content={[`${((totalAfter14[i]/(totalAfter14[0] + totalAfter14[1] + totalAfter14[2])) * 100).toFixed(2)}%`]}
                        children={totalAfter14[i]}
                        style={false}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};